import { Aurelia, autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { Config } from 'Config';
import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { Toastr } from 'Code/Extension/Toastr';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { EventAggregator } from 'aurelia-event-aggregator';
import { SaveProgress } from 'Code/Extension/Progress';

@autoinject
@customElement('notify-wrapper')
export class HeaderWrapper {
    protected dataService: DataService = null;
    protected router: Router = null;
    protected hubConnection: HubConnection = null;
    protected i18n: I18N = null;
    protected ea: EventAggregator = null;
    protected authService: AuthService = null;
    protected openChatIds: Array<number> = [];
    protected openChatNames: Object = {};
    protected sub: any = null;
    protected isMobileDevice: boolean = false;
    protected chatMinimize: Object = {};

    constructor(dataService: DataService, authService: AuthService, router: Router, i18n: I18N, eventAggregator: EventAggregator) {
        this.dataService = dataService;
        this.router = router;
        this.i18n = i18n;
        this.ea = eventAggregator;
        this.authService = authService;

        this.createConnection();
        this.registerOnServerEvents();
        this.startConnection();
    }

    async attached() {
    }

    detached() {
    }
    async bind() {
        this.HalfMinuteTimer();
        this.isMobileDevice = await SystemService.Instance.IsMobileDevice1();
    }

    private publishData() {
        let data1: any = {
        };
        if (ObjectHelper.ObjectIs(this.hubConnection) && ObjectHelper.ObjectIs(this.hubConnection.state)) {
            data1.HubConnectionState = this.hubConnection.state;
            console.log('SignalR - ' + this.hubConnection.state);
        }
        this.ea.publish('half-minute-timer', data1);
    }

    private async HalfMinuteTimer() {
        this.publishData();
        if (ObjectHelper.ObjectIs(this.hubConnection) && ObjectHelper.ObjectIs(this.hubConnection.state)) {
            if (this.hubConnection.state == HubConnectionState.Disconnected) {
                console.log('SignalR - Restart');
                this.sub.dispose();
                this.hubConnection.stop();
                this.sub = null;
                this.hubConnection = null;
                this.createConnection();
                this.registerOnServerEvents();
                this.startConnection();
            }
        }

        setTimeout(() => this.HalfMinuteTimer(), 30000);
    }

    private createConnection() {
        let userInfo = this.authService.GetUserInfo();
        let hubUrl: string = Config.ApiUrl().toLowerCase().replace('vistosapi', '') + 'hubs/Vistos?userToken=' + JSON.parse(localStorage[Config.TokenName()] || null).Token;
        this.hubConnection = new HubConnectionBuilder()
            .withUrl(hubUrl)
            .withAutomaticReconnect()
            //.configureLogging(LogLevel.Information)
            .build();
    }

    private startConnection(): void {
        this.hubConnection
            .start()
            .then(() => {
                console.log('SignalR - Hub connection started');
                this.publishData();
            })
            .catch(err => {
                console.log('SignalR - Error while establishing connection, retrying...');
            });

    }

    private registerOnServerEvents(): void {
        let thisParent = this;

        this.hubConnection.on('TaskNewResponsible', (data: any) => {
            Toastr.Warning('Toastr.Oooops', 'New Task Responsible' + data.id.toString());
            console.log(data);
        });
    }
}